import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";

const ScrollLayout: React.FC = () => {
  const location = useLocation();
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  // 페이지 이동 시 스크롤을 맨 위로 이동
  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [location.pathname]);

  return (
    <div
      ref={scrollContainerRef}
      className="h-full overflow-y-auto overflow-x-hidden p-6 md:p-8 scroll-smooth"
    >
      <div className="max-w-7xl mx-auto animate-fade-in">
        <Outlet />
      </div>
    </div>
  );
};

export default ScrollLayout;
